import React from "react";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";


const footers = [
  {
    title: "O NAS",
    description: [
      { title: "O Micree", url: "https://micree.pl/" },
      { title: "Czym jest micree", url: "https://micree.pl/jak-dziala-micree/" },
      { title: "Czym jest mikropoświadczenie", url: "https://micree.pl/mikroposwiadczenia/" },
      // { title: "Lokalizacja", url: "https://vccsystem.eu/" },
    ],
  },
  // {
  //   title: "O ZSK",
  //   description: [
  //     {
  //       title: "Czym jest ZSK?",
  //       url: "https://vccsystem.eu/system-certyfikacji/rynkowe/opis-systemu-certyfikacji/",
  //     },
  //     {
  //       title: "Kwalifikacje włączone",
  //       url: "https://kwalifikacje.vccsystem.eu/wlaczone-do-zsk/",
  //     },
  //     {
  //       title: "Kwalifikacje procedowane",
  //       url: "https://kwalifikacje.vccsystem.eu/procedowane-2/",
  //     },
  //   ],
  // },
  {
    title: "INFORMACJE",
    description: [
      // { title: "Regulamin", url: "https://micree.pl/" },
      { title: "Regulamin", url: "/regulamin" },
      { title: "Polityka cookies", url: "https://micree.pl/polityka-cookies/" },
      { title: "Polityka prywatności", url: "https://micree.pl/polityka-prywatnosci/" },
    ],
  },
  {
    title: "KONTAKT",
    description: [
      { title: "Kontakt", url: "https://micree.pl/kontakt/" }
    ],
  },
];

export const Footer = () => {
  const theme = useTheme();

  return (
    // <Box sx={{ bgcolor: "background.paper", p: 6 }} component="footer">
    <Box sx={{ bgcolor: "#ffffff5f", p: 6 }} component="footer">
      <Container
        maxWidth="md"
        component="footer"
        sx={{
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          mt: 8,
          py: [3, 6],
        }}
      >
        <Grid container spacing={4} justifyContent="space-evenly">
          {footers.map((footer) => (
            <Grid item xs={12} md={3} sm={3} key={footer.title} sx={{
              textAlign: {
                xs: "center",
                md: "left",
              },
            }}>
              <Typography variant="h6" color={theme.palette.secondary.title} gutterBottom>
                {footer.title}
              </Typography>
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {footer.description.map((item) => (
                  <li key={item.title}>
                    <Link
                      href={item.url}
                      variant="subtitle1"
                      color={theme.palette.secondary.title}
                      style={{ textDecoration: "none" }}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
